module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-fence"
  }, [_c('div', {
    staticClass: "breadcrumb",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("设置围栏\n        "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.clearBtnShow) ? _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveFence
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), (_vm.clearBtnShow) ? _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.clearAll
    }
  }, [_vm._v("清空围栏")]) : _vm._e()], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "80px",
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "围栏名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属跑区"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.runAreaNames),
      callback: function($$v) {
        _vm.runAreaNames = $$v
      },
      expression: "runAreaNames"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search-box"
  }, [_c('el-input', {
    staticClass: "fence-input",
    attrs: {
      "type": "text",
      "placeholder": "请输入搜索地址"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.theLocation.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.schoolName),
      callback: function($$v) {
        _vm.schoolName = $$v
      },
      expression: "schoolName"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.theLocation
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(" 提示：选取最后一个点位时，双击鼠标即可结束画图！ ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    attrs: {
      "id": "my-map"
    }
  }), _vm._v(" "), (_vm.clearBtnShow) ? _c('div', {
    staticClass: "drawing-toolbar"
  }, [_c('div', {
    staticClass: "toolbar-item",
    attrs: {
      "title": "绘制多边形"
    },
    on: {
      "click": _vm.startDrawPolygon
    }
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 2L2 7L12 12L22 7L12 2Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2 17L12 22L22 17"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2 12L12 17L22 12"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("绘制围栏")])]), _vm._v(" "), _c('div', {
    staticClass: "toolbar-item",
    attrs: {
      "title": "清空绘制"
    },
    on: {
      "click": _vm.clearAll
    }
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("清空")])])]) : _vm._e()]), _vm._v(" "), (_vm.clearBtnShow) ? _c('div', {
    staticClass: "margin-top-20 margin-bottom-20"
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "model": _vm.pointForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "框定点位"
    }
  }, [_c('div', {
    staticClass: "flex-row"
  }, [_c('el-select', {
    staticStyle: {
      "flex": "1",
      "margin-right": "8px"
    },
    attrs: {
      "placeholder": "请选择点位",
      "filterable": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pointForm.tmpList),
      callback: function($$v) {
        _vm.$set(_vm.pointForm, "tmpList", $$v)
      },
      expression: "pointForm.tmpList"
    }
  }, _vm._l((_vm.pointList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.pointsNumber,
        "value": item.pid,
        "disabled": _vm.pointForm.selectedList.includes(item.pid)
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickAddPoint
    }
  }, [_vm._v("添加")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "已框点位"
    }
  }, [_c('div', {
    staticClass: "card-wrap"
  }, _vm._l((_vm.pointForm.selectedOptions), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "dialog-item"
    }, [_c('div', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "icon": "circle-close"
      },
      on: {
        "click": function($event) {
          return _vm.clickDeletePoint(item)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("共" + _vm._s(_vm.pointForm.selectedList.length) + "个点位")])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.clearBtnShow) ? _c('div', {
    staticClass: "margin-top-20 margin-bottom-20"
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 6
    }
  }, [_c('div', [_c('div', {
    staticClass: "flex-row-between"
  }, [_c('span', [_vm._v("框定点位")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.clickEditPoints()
      }
    }
  }, [_vm._v("编辑")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-wrap"
  }, _vm._l((_vm.runGeoFencePoints), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "card-item"
    }, [_vm._v("\n                            " + _vm._s(item.serialNum) + "\n                        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("共" + _vm._s(_vm.runGeoFencePoints.length || 0) + "个位点")])])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "框定点位",
      "size": "tiny",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.dialogPointVisible),
      callback: function($$v) {
        _vm.dialogPointVisible = $$v
      },
      expression: "dialogPointVisible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "model": _vm.pointForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择点位"
    }
  }, [_c('div', {
    staticClass: "flex-row"
  }, [_c('el-select', {
    staticStyle: {
      "flex": "1",
      "margin-right": "8px"
    },
    attrs: {
      "placeholder": "请选择点位",
      "filterable": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pointForm.tmpList),
      callback: function($$v) {
        _vm.$set(_vm.pointForm, "tmpList", $$v)
      },
      expression: "pointForm.tmpList"
    }
  }, _vm._l((_vm.pointList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.pointsNumber,
        "value": item.pid,
        "disabled": _vm.pointForm.selectedList.includes(item.pid)
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickAddPoint
    }
  }, [_vm._v("添加")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "已框点位"
    }
  }, [_c('div', {
    staticClass: "card-wrap"
  }, _vm._l((_vm.pointForm.selectedOptions), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "dialog-item"
    }, [_c('div', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "icon": "circle-close"
      },
      on: {
        "click": function($event) {
          return _vm.clickDeletePoint(item)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("共" + _vm._s(_vm.pointForm.selectedList.length) + "个点位")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogPointVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveEditUgrpids
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c75199f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xiaoyuan/GX/newFence.vue
// module id = 978
// module chunks = 0